module.exports = __webpack_public_path__ + "static/media/btn.28a0f6a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/btn.png
// module id = 1316
// module chunks = 0